import { render, staticRenderFns } from "./_tabWorkFlo.vue?vue&type=template&id=49d50cb6&scoped=true&"
import script from "./_tabWorkFlo.vue?vue&type=script&lang=js&"
export * from "./_tabWorkFlo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d50cb6",
  null
  
)

export default component.exports